import { defineMessages } from 'react-intl';

export default defineMessages({
    insuranceHistoryTitle: {
        id: 'wmic-pe-capability-gateway-policyrenewal-pa-react.pages.InsuranceHistory.WMICPARenewalInsuranceHistoryPage.Title',
        defaultMessage: 'Insurance History'
    },
});
